// eslint-disable-next-line max-params
export const calcDelayTime = (string, WPM = 80, maxDelay = 2000, minDelay = 600) => {
  if (!string) return maxDelay;
  try {
    const promptLength = string.split(' ').length;
    const delayTime = (promptLength / WPM) * (60 * 500) + minDelay;
    if (delayTime > maxDelay) return maxDelay;
    return delayTime;
  } catch (e) {
    return maxDelay;
  }
};

export const isCustomNumber = property => {
  if (!/_custom_/.test(property)) return false;
  return property.substring(property.length - 3) === 'Num';
};
